import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLorryTransportContractor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53,
    fill: "none",
    viewBox: "0 0 54 53"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0040BF",
    d: "M26.4 37.97v-.78L0 21.06V6.21l13.13 7.93 13.38 8c-.1 2.53-.17 5.15-.19 7.84-.02 2.69 0 5.38.07 8l.01-.01z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M51.83 29.51v5l-1.35.85v-5l1.35-.85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#232E3E",
    d: "M26.4 42.67l2.37-1.08-2.43-1.66.06 2.74z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00334F",
    d: "M39 14.63l.06 15.31-12.66 8.04-.15-17.56L39 14.63z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEF5FE",
    d: "M26.83 25.34l11.57-6.85c.16-.059.33-.083.5-.07.197.027.385.1.55.21.38.26 3.88 2.35 8.73 5.25a7.295 7.295 0 012.11 2.62c.182.372.33.76.44 1.16.3 1.51.49 2.81.63 3.8.26 2 .39 3.64.49 5 0 .72.09 1.32.12 1.76l-1.09 2.14-.87.82-5.92 3.49-1.08.14-2.37-.08c0-.36-.07-.91-.14-1.6 0-.49-.06-.68-.09-1-.07-.83-.09-1.43-.1-1.77a33.948 33.948 0 00-.55-4.78 8.523 8.523 0 00-.36-1.39 7.154 7.154 0 00-1-1.85 8.73 8.73 0 00-2-1.86l-.44-.31a18.802 18.802 0 00-1.78-1.06c-.49-.26-1-.58-2-1.22 0 0-2.21-1.37-4.26-2.45a1.215 1.215 0 00-.4-.14 1.347 1.347 0 00-.69.04z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#004D82",
    d: "M26.4 37.19v.78C17.6 32.723 8.8 27.48 0 22.24v-1.18l26.4 16.13zm-.14-15.12L0 6.21l26.25 14.21c0 .57.01 1.1.01 1.65z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00334F",
    d: "M26.4 42.67L0 26.93v-5.87l26.4 16.13v5.48z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAE5EF",
    d: "M26.33 39.93V38.6c-.11-3.54-.06-12.65.41-13.18.47-.53 1.68.24 2.15.51l5.39 3.18c1.371.64 2.61 1.532 3.65 2.63a8.62 8.62 0 011 1.48 10.486 10.486 0 011.18 4.8c.18 3.24 1.13 12.56.9 13.67a.77.77 0 01-.29.51.59.59 0 01-.43 0c-.65-.13-6.41-3.82-7-4.19a7.417 7.417 0 00-.22-3.59 6.397 6.397 0 00-3-3.76 2.652 2.652 0 00-1.59-.32c-.355.046-.696.17-1 .36l-1.15-.77z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3D53",
    d: "M27.05 36.3a.56.56 0 01-.05-.31l.1-7.63c0-.55 0-1.32.61-1.5.61-.18 1.84.72 2.07.84l4 2.11a11.346 11.346 0 013.09 2.13 8.375 8.375 0 012 4.85c.19 1.78.73 3.89.54 5.67a.77.77 0 01-.809.63 2.242 2.242 0 01-1-.41c-3.31-2.02-7.2-4.26-10.39-6.26a1.589 1.589 0 01-.16-.12zm24-1.51a4.216 4.216 0 01-.57.74 5.44 5.44 0 01-.66.6c-.55.42-3 2-6.31 4a2.062 2.062 0 01-1.36.45h-.27a2.009 2.009 0 01-1-.52c0 .24.06.45.09.68v.36a.273.273 0 000-.07v-.06a.215.215 0 010-.08 4.235 4.235 0 01-.06-.5V39.72c-.2-1.64-.39-3.28-.59-4.91a1.654 1.654 0 01.08-1c.206-.42.563-.745 1-.91.7-.32 2.12-1.15 3.58-2l4.12 3.25c.11.08.69.52 1 .3.31-.22.28-.54.29-.83a37.69 37.69 0 00-.73-5.7.526.526 0 01.39 0 .793.793 0 01.32.57c.49 2.77.61 4.75.73 6-.07.06-.07.19-.05.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFDD2",
    d: "M39.611 44.81v2.85l.74 1.65 1 .09 3.64-2.11-.77-1.82-1.16-.66h-2a.99.99 0 01-.36 0c-.28-.08-.36-.26-.54-.27-.18-.01-.33-.04-.55.27zm10.609-.76l.24-2.7.66-1.55.85-1.66.14 4.7-1.89 1.21z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3D53",
    d: "M39.401 49.62l-.12 2c.337.4.811.66 1.33.73.354.005.7-.093 1-.28.88-.53 5.34-3.22 11.43-7 .31-.186.56-.456.72-.78.141-.275.21-.581.2-.89a1.846 1.846 0 00-.48-1.13l-.47.83-11.39 7-1.33.1-.89-.58z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#6784A8",
    d: "M43.01 44.81l1.08-.14 5.92-3.49.87-.82-.42 1-.24 2.7c-1 .65-2.07 1.3-3.13 1.94-.72.44-1.43.88-2.15 1.3l-.77-1.82-1.16-.67zm7.29-11.27c0 .29-.05.67-.29.83-.24.16-.93-.22-1-.3l-4.12-3.25c1.71-1 3.45-2.16 4.09-2.62.103-.08.21-.153.32-.22.082-.026.162-.056.24-.09.396 1.862.65 3.75.76 5.65z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#232E3E",
    d: "M51.08 36.17c-.027.08-.06.156-.1.23l-.06.11a2.377 2.377 0 01-.21.28l-.12.12c-1.28.76-2.56 1.54-3.86 2.34l-3.72 2.33a1.255 1.255 0 01-1.329.21 1.379 1.379 0 01-.7-.77v-.36c0-.23-.05-.44-.09-.68.276.266.623.446 1 .52.09.011.18.011.27 0 .492.017.975-.142 1.36-.45 3.33-2 5.76-3.53 6.31-4 .236-.181.456-.382.66-.6.216-.225.408-.473.57-.74.014.164.038.328.07.49a.818.818 0 010 .14c.044.277.027.56-.05.83z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD9F0",
    d: "M31.53 44.59c.54 1.33.28 2.73-.58 3.13-.86.4-2-.36-2.54-1.68-.54-1.32-.28-2.73.58-3.13.86-.4 2 .36 2.54 1.68zm-2-.41c-.41.18-.53.83-.28 1.45s.79 1 1.19.79c.4-.21.52-.84.27-1.46s-.8-.97-1.2-.78h.02z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3D53",
    d: "M32.94 43.95c1.09 2.66.56 5.47-1.17 6.28-1.73.81-4-.71-5.1-3.37-1.1-2.66-.55-5.48 1.18-6.28 1.73-.8 4.01.71 5.09 3.37zm-4-1c-.86.4-1.12 1.8-.58 3.13.54 1.33 1.67 2.08 2.54 1.68.87-.4 1.12-1.8.58-3.13-.54-1.33-1.62-2.12-2.49-1.72l-.05.04z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#6382AA",
    d: "M30.384 46.427c.415-.151.566-.783.338-1.41-.229-.629-.75-1.015-1.166-.864-.415.15-.566.782-.338 1.41.229.628.75 1.015 1.166.864z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#232E3E",
    d: "M31.91 50.15l2.49-1.46-1-.63a4.744 4.744 0 01-.8 1.42c-.203.25-.435.474-.69.67z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD9F0",
    d: "M8.591 30.27c.54 1.33.28 2.73-.58 3.13-.86.4-2-.35-2.54-1.68s-.28-2.72.58-3.12c.86-.4 2 .35 2.54 1.67zm-2-.41c-.4.18-.53.84-.27 1.46s.78 1 1.18.78c.4-.22.52-.84.27-1.46s-.8-.97-1.2-.78h.02z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3D53",
    d: "M10 29.63c1.09 2.67.56 5.48-1.17 6.28-1.73.8-4-.71-5.1-3.37-1.1-2.66-.55-5.48 1.18-6.28 1.73-.8 4.01.71 5.09 3.37zm-3.95-1c-.86.4-1.12 1.79-.58 3.12.54 1.33 1.68 2.08 2.54 1.68.86-.4 1.12-1.8.58-3.13-.54-1.33-1.67-2.1-2.54-1.7v.03z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#6382AA",
    d: "M7.44 32.112c.416-.151.567-.783.339-1.41-.229-.629-.75-1.015-1.166-.864-.415.15-.566.782-.338 1.41.228.628.75 1.015 1.165.864z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#232E3E",
    d: "M8.97 35.83L12.19 34l-1.65-1a4.833 4.833 0 01-.93 2.14 3.706 3.706 0 01-.64.69zm35.311 9.18l5.82-3.47-.2 2.07-.31.45-3.85 2.37-.73-.11-.73-1.31z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E53FB",
    d: "M39 14.63l-12.74 7.44L0 6.21 12.9 0 39 14.63z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#232E3E",
    d: "M39.4 49.62l.85-.52 1 .3 5.79-3.41 5-3.15v-1.4l1.45.89a.788.788 0 010 .42.667.667 0 01-.44.41l-11.39 7a1.051 1.051 0 01-1.33.1l-.93-.64z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA840",
    d: "M36.82 43.95v.55l1.66 1v-.53l-1.66-1.02z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M39.82 37.98v5l-1.34.85v-5l1.34-.85z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#232E3E",
    d: "M40.54 41.01l-.71.13-.67-.13v-.39l.69.1.69-.1v.39z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LorryTransportContractor_svg__paint0_linear)",
    d: "M14.34 33.52l-5.62-1.61-7.39 1.93 4.66 2.03 8.35-2.35z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA55",
    d: "M6.04 36.67l-.05-.8-4.66-2.03v.03l.12 9.19 4.63 2.11-.04-8.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB8C00",
    d: "M14.34 33.55v-.03l-8.35 2.35.05.8.04 8.5 8.31-2.63-.05-8.99z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#00334F",
    d: "M3.57 34.82h-.01l-.6-.26v.03l.08 1.09.01-.01.05.13.05-.08.04.12.06-.06.04.26.09-.15.05.12.07-.06.06.11.05-.12.05.15-.09-1.24v-.03z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#CF9558",
    d: "M10.81 32.51l-7.85 2.04v.01l.6.26h.01l7.99-2.09-.75-.22z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.33 33.84l4.66 2s-2.84-1.35-4.66-2zm4.8 1.99l8.12-2.28s-5.85 1.51-8.12 2.28zm-.09 9.25v-8.94s-.14 6.42 0 8.94z",
    opacity: 0.7
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LorryTransportContractor_svg__paint1_linear)",
    d: "M21.251 36.36l-5.06-1.45-6.66 1.74 4.2 1.83 7.52-2.12z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA55",
    d: "M13.781 39.19l-.05-.71-4.2-1.83v.03l.11 8.27 4.18 1.9-.04-7.66z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB8C00",
    d: "M21.25 36.39v-.03l-7.52 2.12.05.71.04 7.66 7.47-2.37-.04-8.09z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#00334F",
    d: "M11.55 37.53l-.54-.24v.03l.06.99.01-.02.05.12.04-.07.04.11.05-.06.04.24.08-.14.05.11.06-.06.05.1.05-.1.04.14-.08-1.12v-.03z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#CF9558",
    d: "M18.07 35.45l-7.06 1.84.54.24 7.2-1.89-.68-.19z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.531 36.65l4.2 1.83s-2.56-1.25-4.2-1.83zm4.33 1.77l7.31-2s-5.28 1.32-7.31 2zm-.081 8.35v-8.06s-.13 5.79 0 8.06z",
    opacity: 0.7
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LorryTransportContractor_svg__paint2_linear)",
    d: "M17.921 31.44l-3.04-.88-4.01 1.05 2.53 1.1 4.52-1.27z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA55",
    d: "M13.431 33.14l-.03-.43-2.53-1.1v.02l.07 4.97 2.51 1.14-.02-4.6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB8C00",
    d: "M17.92 31.45v-.01l-4.52 1.27.03.43.02 4.6 4.5-1.42-.03-4.87z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#00334F",
    d: "M12.09 32.14l-.33-.14v.01l.04.6.01-.01.03.07.02-.04.02.06.04-.03.02.14.04-.08.03.06.04-.03.03.06.03-.06.03.08-.05-.68v-.01z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#CF9558",
    d: "M16.01 30.89L11.76 32l.33.14L16.42 31l-.41-.11z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.871 31.61l2.53 1.1s-1.54-.75-2.53-1.1zm2.609 1.08l4.4-1.27s-3.18.85-4.4 1.27z",
    opacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "LorryTransportContractor_svg__paint0_linear",
    x1: 794.29,
    x2: 1002.61,
    y1: 955.144,
    y2: 943.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E5B785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#DEAE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DBA975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D29C67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE9662"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "LorryTransportContractor_svg__paint1_linear",
    x1: 822.079,
    x2: 991.056,
    y1: 878.108,
    y2: 868.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E5B785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#DEAE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DBA975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D29C67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE9662"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "LorryTransportContractor_svg__paint2_linear",
    x1: 506.345,
    x2: 567.503,
    y1: 523.663,
    y2: 520.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#E5B785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#DEAE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DBA975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D29C67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE9662"
  })))));
}

export { SvgLorryTransportContractor as ReactComponent };
//# sourceMappingURL=LorryTransportContractor.svg.js.map
